@if (data) {
  <span [innerHTML]="data | translate | iconReplace"></span>
}
